module.exports = __webpack_public_path__ + "img/vuejs-plugin-nyancat.b3af59c0.png";